<template>
	<svg id="Layer_1" enable-background="new 0 0 512.003 512.003" viewBox="0 0 512.003 512.003" xmlns="http://www.w3.org/2000/svg" :height="height" :width="width"><g><g><path :fill="color" d="m447.996 128.003c0-52.821 18.944-78.613 19.115-78.805 3.285-4.245 2.901-10.283-.896-14.08l-32-32c-3.349-3.349-8.512-4.075-12.651-1.813-.384.192-37.227 20.032-80.235 20.032-42.773 0-79.872-19.84-80.235-20.032-3.179-1.707-7.04-1.728-10.197 0-.384.192-37.227 20.032-80.235 20.032-42.773 0-79.872-19.84-80.235-20.032-4.139-2.24-9.301-1.515-12.629 1.835l-32 32c-3.755 3.755-4.139 9.771-.939 14.016.192.256 19.136 26.048 19.136 78.869 0 24-3.883 40.64-8.384 59.904-6.08 26.005-12.949 55.488-12.949 110.763 0 101.333 78.805 147.776 208.597 212.224 1.493.704 3.115 1.088 4.736 1.088s3.243-.384 4.736-1.109c129.792-64.448 208.597-110.891 208.597-212.224 0-55.296-6.891-84.757-12.949-110.763-4.479-19.244-8.383-35.883-8.383-59.905zm-77.781 92.885-49.067 49.067 19.179 76.715c.917 1.579 1.429 3.392 1.429 5.333 0 5.973-5.867 11.093-10.88 10.667h-.213c-1.813 0-3.648-.469-5.291-1.408l-69.376-39.637-69.376 39.637c-3.712 2.112-8.32 1.813-11.733-.768s-4.949-6.933-3.904-11.093l19.861-79.488-49.067-49.067c-2.859-2.859-3.861-7.083-2.581-10.923s4.608-6.613 8.597-7.189l68.736-9.813 29.653-69.163c3.349-7.851 16.256-7.851 19.605 0l29.653 69.163 68.736 9.813c4.011.576 7.339 3.349 8.597 7.189 1.282 3.861.279 8.107-2.558 10.965z"/></g></g><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/></svg>
</template>

<script>
export default {
	name: "ModeratorBadgeIcon",
	props: {
		height: {
			type: Number,
			default: 20
		},
		width: {
			type: Number,
			default: 20
		},
        color: {
            type: String,
            default: '#ffffff'
        },
  	}
}
</script>
